<template>
    <div>
       
        <buttonlist  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
        <div style="display: flex">
            <div style="width:20%;">
                <div :style="{height: treeheight1}">
                    <el-card class="box-card" style="height:100%">
                        <div class='tree-container' style="margin-top:5px;inbackground: white;height:700px;">
                            <el-scrollbar style="height:100%;width:100%;overflow-y:auto;">
                                <el-tree class="tree" 
                                    :indent="0" :data="dataTree" :props="defaultProps" node-key="TreeID" :default-expanded-keys="defaultEexpandedkeys1" @node-click="handleNodeClick"></el-tree>
                            </el-scrollbar>
                        </div>
                    </el-card>
                </div>
            </div>
            <div style="width:80%">
                <el-card class="box-card" :style="{height: treeheight1}">
                    <el-table
                            id="xpane-0"
                            :data="dataSet"
                            v-loading="loading"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            :height="tableHeight"
                            @cell-dblclick="editInfo"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:0px"
                            :header-cell-style="$limits.headerClass"
                            ref="singleTable"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="usernum" :label="$t('getapi[3223]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="userid" :label="$t('getapi[3225]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="username" :label="$t('getapi[3226]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="deptname" :label="$t('getapi[3151]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="postname" :label="$t('getapi[3228]')" width="100"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')" width="100"></el-table-column>
                        <el-table-column :label="$t('getapi[6048]')" width="80">
                            <template slot-scope="scope">
                                <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{
                                    $t('getapi[3558]') }}
                                </el-button>
                                <span v-if="pertype!='M'">
                                    <el-button  @click.native.prevent="deluserlv(scope.row)" type="text" size="small">{{
                                        $t('getapi[3889]') }}
                                    </el-button>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </div>
        <serce :isVisible="isVisible" queryData="FrmUserPerShowViewInfo" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :visible.sync="isShowDetail" width="50%">
            <div>
                <el-divider content-position="left">{{$t('getapi[3543]')}}</el-divider>
                <table>
                    <tr>
                        <td>{{$t('getapi[3201]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.UserName" type="text" size="mini" :disabled="true"></el-input>
                        </td>
                        <td>{{$t('getapi[3151]')}}</td>
                        <td>
                            <el-select filterable v-model="dataDetail.DeptID" :placeholder="$t('getapi[6085]')" size="mini">
                                <el-option v-for="item in arrDept" :key="item.num" :label="item.name" :value="item.num"></el-option>
                            </el-select>
                            <!--<el-input v-model="dataDetail.deptname" type="text" size="mini"></el-input>-->
                        </td>
                        <td>{{$t('getapi[3165]')}}</td>
                        <td>
                            <el-select filterable v-model="dataDetail.PostID" :placeholder="$t('getapi[6085]')" size="mini">
                                <el-option v-for="item in arrPost" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                            </el-select>
                            <!--<el-input v-model="dataDetail.postname" type="text" size="mini"></el-input>-->
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3255]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.UserID" type="text" size="mini" :disabled="true"></el-input>
                        </td>
                        <td>ID</td>
                        <td>
                            <el-input v-model="dataDetail.CpuID" type="text" size="mini"></el-input>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
            </div>
            <div style="display: flex">
                <div style="width:25%">
                    <div>
                        <el-divider content-position="left">{{$t('getapi[3546]')}}</el-divider>
                        <div style="height:300px">
                            <el-table
                                    :data="roleDetail"
                                    size="mini"
                                    style="width: 100%"
                                    :highlight-current-row="true">
                                <el-table-column prop="rolename" label="" width="180"></el-table-column>
                            </el-table>
                            <!--<ul>
                                <li v-for="item in roleDetail" :key="item.roleid">{{item.rolename}}</li>
                            </ul>-->
                        </div>
                    </div>
                </div>
                <div style="width:75%">
                    <div>
                        <el-divider content-position="left">{{$t('getapi[3547]')}}</el-divider>
                        <table>
                            <td>{{$t('getapi[3548]')}}</td>
                            <td>
                                <el-input  v-model="treeQueryKey" type="text" size="mini"></el-input>
                            </td>
                            <td><el-button size="mini" @click="searchTree">查询</el-button></td>
                            <td><el-button size="mini" @click="back">{{$t('getapi[3549]')}}</el-button></td>
                            <td><el-button size="mini" @click="next">{{$t('getapi[3550]')}}</el-button></td>
                        </table>
                    </div>
                    <div style="height:300px;overflow: scroll" id="searchtree-eletree">
                        <el-tree ref="tree"
                                 :data="detailDataTree"
                                 :props="detailDefaultProps"
                                 show-checkbox
                                 check-strictly
                                 highlight-current
                                 node-key="TreeID"
                                 :default-checked-keys="defaultchecked"
                                 :default-expanded-keys="defaultEexpandedkeys"
                                 :filter-node-method="filterNode"
                        ></el-tree>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false">{{$t('getapi[2054]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'authoritysearch',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-160
            },
            treeheight1(){
                return this.$windowSize.tableHeight - 155 + 'px'
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                isShowDetail: false, //
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail:{},
                dataTree: [], // 角色分类树
                defaultProps: {
                    children: 'Children',
                    label: 'PerName',
                    PLevel:'PLevel',
                    ParentTreeID:"ParentTreeID",
                    TreeID:"TreeID",
                    PerType:'PerType',
                    PerMainPos:'PerMainPos',
                    PerSubPos:'PerSubPos',
                    MainPos:'MainPos',
                    IsCheck:'IsCheck',
                },
                detailDataTree: [],
                detailDefaultProps: {
                    children: 'Children',
                    label: 'PerName',
                    PLevel:'PLevel',
                    ParentTreeID:"ParentTreeID",
                    TreeID:"TreeID",
                    PerType:'PerType',
                    PerMainPos:'PerMainPos',
                    PerSubPos:'PerSubPos',
                    MainPos:'MainPos',
                    IsCheck:'IsCheck',
                },
                defaultchecked: [],
                defaultEexpandedkeys: [],
                searchIndex: null,
                searchData: [], //模糊匹配的树节点
                treeQueryKey: '',
                arrDept: [], //部门信息
                arrPost: [], // 岗位信息
                arrRoleGroup: [],
                defaultEexpandedkeys1: [],
                pertype: '',
                permainpos: 0,
                mainpos: 0,
                persubpos:0,
                perid:'',
                scrollTop:0,
            };
        },
        created: function() {
            let that = this;
            that.arrDept = Array.methods.getDeptInfo();
            that.arrPost = Array.methods.getPostInfo();
            that.arrRoleGroup = Array.methods.getRoleGroup()
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView()
            that.authority() ;
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            filterNode(value,data){
                return data.Visiable == value
            },
            filterChange(){
                this.$nextTick(() => {
                    this.$refs.tree.filter(1)
                    // 当执行过滤后，会默认展开，这边遍历树，全部收缩
                    this.shrink().filter(this.detailDataTree);
                })
            },
            shrink: function(){
                let that = this
                let shrink_ = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.TreeID != '-') {
                        that.$refs.tree.store.nodesMap[obj.TreeID].expanded = false
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            shrink_(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            shrink_(rootMenu);
                        }
                    }
                };
            },
            authority() {
                let that = this;
                console.log("1");
                if (that.$limits.authority('plv2', 10,1) == 1) {//只读权
                console.log("12");
                    that.$refs.SetBtn.SetButtonEnable('refresh');
                }
                if (that.$limits.authority('plv2', 10,1) == 2) {//操作权
                     if (that.$limits.authority('plv3', 10,1) == 0) {//查询级
                         that.$refs.SetBtn.SetButtonEnable('refresh');
                     } 
                     if (that.$limits.authority('plv3', 10,1) == 1) {//编辑级
                         that.$refs.SetBtn.SetButtonEnable('refresh');
                     }
                     if (that.$limits.authority('plv3', 10,1) == 2) {//删除级
                         that.$refs.SetBtn.SetButtonEnable('refresh');
                     }
                }
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.getView();
                this.intidata()
            },
            getView(){
                let that = this
                let parm = {}
                that.$http.urlpost('/Sys/Authority/GetUserAuthority', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataTree = res.DataContent.listTree;
                        that.defaultEexpandedkeys1.push('-');
                        that.authority() ;
                    }
                });
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmUserPerShowViewInfo');
            },
            reflash() {
                let that = this;
                that.getView();
            },
            handleNodeClick(data){
                let that = this
                    that.perid= data.TreeID;
                    that.pertype= data.PerType;
                    that.permainpos= data.PerMainPos;
                    that.mainpos= data.MainPos;
                    that.persubpos= data.PerSubPos
                let parm = {
                    pertype: data.PerType,
                    permainpos: data.PerMainPos,
                    mainpos: data.MainPos,
                    persubpos: data.PerSubPos
                }
                that.$http.urlpost('/Sys/Authority/GetUserInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false
                        that.authority() ;
                    }
                });
            },
            intidata(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    Param: datac
                };
                that.$http.urlpost('/Sys/Authority/GetUserInfo', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            freeze(data){
                let that = this
                let parm = {
                    type: 1,
                    userid: that.user
                }
                that.$http.urlpost('/Sys/Authority/FrozenUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.authority() ;
                    }
                });
            },
            draw(data){
                let that = this
                let parm = {
                    type: 2,
                    userid: that.user
                }
                that.$http.urlpost('/Sys/Authority/FrozenUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.authority() ;
                    }
                });
            },
            editInfo(data) {
                let that = this
                that.isShowDetail = true
                that.defaultEexpandedkeys = []
                let parm = {
                    UserNum: data.usernum
                }
                that.$http.urlpost('/Sys/Authority/GetUserRoleAuthorityListNew', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent.UserInfo
                        that.roleDetail = res.DataContent.RoleGroupList
                        that.detailDataTree = res.DataContent.AuthorityList
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                        that.defaultEexpandedkeys.push('-');
                        that.filterChange()
                        that.authority() ;
                    }
                });
            },
            deluserlv(data) {
                let that = this
                this.$confirm('确定删除【'+data.username+'】权限吗?', that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            userid: data.lvnum,
                            perid:that.perid,
                            pertype:that.pertype,
                            permainpos:that.permainpos,
                            mainpos:that.mainpos,
                            persubpos:that.persubpos
                        }
                        that.$http.urlpost('/Sys/Authority/DelUserLv', parm, function (res) {
                            if (res.Success == 1) {    
                                that.refresh();            
                                that.filterChange();
                                that.authority() ;
                            }
                        });
                    
                     })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            refresh(){
                let that = this
                let parm = {
                    pertype:that.pertype,
                    permainpos:that.permainpos,
                    mainpos:that.mainpos,
                    persubpos:that.persubpos
                }
                that.$http.urlpost('/Sys/Authority/GetUserInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false
                        that.authority() ;
                    }
                });
            },
            tickMenuIdFilter: function() {
                let that = this
                that.defaultchecked = [];
                let parentPerIDArr = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.IsCheck == true) {
                        that.defaultchecked.push(obj.TreeID);
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        that.$refs.tree.setCheckedKeys(that.defaultchecked)
                        return that.defaultchecked;
                    }
                };
            },
            searchTree(){
                let that = this
                if(that.treeQueryKey == ""){
                    that.$message.warning(that.$t('getapi[8833]'));//'请输入查询关键字！'
                    return
                }
                that.searchIndex = null;
                that.defaultEexpandedkeys = []
                that.searchData = []
                let searchInput = that.treeQueryKey;
                that.getSearchNode().filter(that.detailDataTree)
                if (this.searchData.length) {//存在符合查询条件的节点
                    this.searchIndex = 0;
                    //展开符合条件节点的父节点（使查询节点显示出来）
                    that.defaultEexpandedkeys = that.getParentsId(this.searchData[0], this.detailDataTree, 'TreeID','ParentTreeID', '01');
                    console.log(that.defaultEexpandedkeys)
                    this.$nextTick(() => {//显示完成后执行
                        this.$refs.tree.setCurrentKey(this.searchData[0].TreeID);//高亮查询到的第一个节点
                    });
                } else {
                    //Message需要引入  import {Message} from 'element-ui'
                    that.$message.warning(that.$t('getapi[8832]'));//'未找到任何匹配数据！'
                }
            },
            next() {
                let that = this
                console.log(that.searchIndex)
                console.log(that.searchData)
                if(that.searchIndex >= that.searchData.length -1){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex += 1;
                that.searchIndex = that.searchIndex < that.searchData.length ? that.searchIndex : 0;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'TreeID','ParentTreeID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].TreeID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            back() {
                let that = this
                if(that.searchIndex == 0){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex -= 1;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'TreeID','ParentTreeID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].TreeID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            getSearchNode:function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.PerName.indexOf(that.treeQueryKey) > -1){
                        that.searchData.push(arr)
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.searchData
                    }
                }
            },
            getParentsId(node, data, TreeID, ParentTreeID, rootId, parentsId = [] ){
                let that = this
                if(!node) return [rootId, ...parentsId];
                if(node[ParentTreeID] == rootId) return [node[ParentTreeID], ...parentsId];
                /*let pNode = data.filter(item => item[TreeID] == node[ParentTreeID]);*/
                let pNode = that.getParentNode(node[ParentTreeID]).filter(data)
                console.log('7777' + pNode)
                if(!pNode.length) return parentsId;
                parentsId.push(pNode[0][TreeID]);
                return that.getParentsId(pNode[0], data, TreeID, ParentTreeID, rootId, parentsId);
            },
            position(){
                this.$nextTick(() => {
                    let that = this
                    let top1 = $("#searchtree-eletree").position().top;
                    let top2 = $("#searchtree-eletree .is-current").position().top
                    let value = top2 - top1
                    $("#searchtree-eletree").scrollTop(value)
                })
            },
            getParentNode: function(ParentTreeID){
                let that = this
                let parentID = []
                let recursiveArray = function(arr){
                    if(arr.TreeID == ParentTreeID){
                        parentID.push(arr)
                        return
                    } else {
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu);
                        }
                        return parentID
                    }
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
    /deep/.el-scrollbar__wrap{
        overflow: scroll;
        overflow-y: scroll;
    }


    .tree-container {
  overflow: hidden;
}
.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 0 ;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 12px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
  border-left: 1px dashed #4386c6;
  bottom: 0px;
  height: 100%;
  top: 0px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
  border-top: 1px dashed #4386c6;
  height: 20px;
  top:12px;
  width: 10px ;
}
</style>
